/* Foz Collectables — free-shipping progress bar ($200 threshold) — v2
   - Fill grows as a % of cart total up to $200, animating from the previous value
   - Larger bar, brand-gold fill with moving stripes, green when unlocked
   - Fill/track forced to display:block so theme rules can't collapse an empty div */
(function () {
  var THRESHOLD = 20000; // $200.00 AUD, in cents
  var lastPct = null;

  function injectCSS() {
    if (document.getElementById('foz-fsb-css')) return;
    var s = document.createElement('style');
    s.id = 'foz-fsb-css';
    s.textContent = [
      '.foz-fsb-wrap{padding:16px 0 12px;}',
      '.foz-fsb{max-width:720px;margin:0 auto;}',
      '.foz-fsb__msg{margin:0 0 12px;text-align:center;font-size:1.7rem;line-height:1.35;letter-spacing:.02rem;color:rgb(var(--color-foreground,240,240,240));}',
      '.foz-fsb__msg strong{color:#FCE477;}',
      '.foz-fsb.is-reached .foz-fsb__msg strong{color:#2ecc71;}',
      '.foz-fsb__track{display:block!important;position:relative;height:20px;border-radius:999px;background:rgba(var(--color-foreground,240,240,240),0.12);box-shadow:inset 0 1px 3px rgba(0,0,0,.45);overflow:hidden;}',
      '.foz-fsb__fill{display:block!important;position:relative;height:100%;border-radius:999px;background:linear-gradient(90deg,#f5c518 0%,#FCE477 100%);box-shadow:0 0 12px rgba(252,228,119,.55);transition:width .7s cubic-bezier(.22,1,.36,1);overflow:hidden;}',
      '.foz-fsb__stripes{display:block!important;position:absolute;top:0;right:0;bottom:0;left:0;background-image:repeating-linear-gradient(45deg,rgba(255,255,255,.28) 0 10px,rgba(255,255,255,0) 10px 20px);background-size:28px 28px;animation:foz-fsb-move 1s linear infinite;}',
      '.foz-fsb.is-reached .foz-fsb__fill{background:linear-gradient(90deg,#27ae60 0%,#2ecc71 100%);box-shadow:0 0 14px rgba(46,204,113,.6);}',
      '.foz-fsb__meta{display:flex;justify-content:space-between;gap:12px;margin-top:8px;font-size:1.3rem;color:rgba(var(--color-foreground,240,240,240),0.72);}',
      '.foz-fsb__meta b{color:rgb(var(--color-foreground,240,240,240));font-weight:600;}',
      '@keyframes foz-fsb-move{from{background-position:0 0;}to{background-position:28px 0;}}',
      '@media (prefers-reduced-motion:reduce){.foz-fsb__stripes{animation:none;}.foz-fsb__fill{transition:none;}}',
      '@media screen and (max-width:749px){.foz-fsb__msg{font-size:1.5rem;}.foz-fsb__track{height:16px;}.foz-fsb__meta{font-size:1.2rem;}}'
    ].join('');
    document.head.appendChild(s);
  }

  function fmt(cents) { return '$' + (cents / 100).toFixed(2); }

  function calc(total) {
    var remaining = THRESHOLD - total;
    var reached = remaining <= 0;
    var realPct = reached ? 100 : Math.floor(total / THRESHOLD * 100);
    // keep a visible sliver for small carts so the bar never reads as empty
    var barPct = reached ? 100 : Math.max(4, Math.min(100, total / THRESHOLD * 100));
    return { remaining: remaining, reached: reached, realPct: realPct, barPct: barPct };
  }

  function html(total, startPct) {
    var c = calc(total);
    var msg = c.reached
      ? '🎉 You’ve unlocked <strong>FREE shipping!</strong>'
      : 'You’re <strong>' + fmt(c.remaining) + '</strong> away from <strong>FREE shipping</strong>';
    var meta = c.reached
      ? '<span><b>' + fmt(total) + '</b> in cart</span><span><b>100%</b> — free shipping applied</span>'
      : '<span><b>' + fmt(total) + '</b> of ' + fmt(THRESHOLD) + '</span><span><b>' + c.realPct + '%</b> there</span>';
    return '<div class="foz-fsb-wrap"><div class="foz-fsb' + (c.reached ? ' is-reached' : '') + '">'
      + '<p class="foz-fsb__msg">' + msg + '</p>'
      + '<div class="foz-fsb__track" role="progressbar" aria-label="Progress to free shipping" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + c.realPct + '">'
      +   '<div class="foz-fsb__fill" data-target="' + c.barPct + '" style="width:' + startPct + '%;"><span class="foz-fsb__stripes"></span></div>'
      + '</div>'
      + '<div class="foz-fsb__meta">' + meta + '</div>'
      + '</div></div>';
  }

  var observers = [];
  function pauseAll() { observers.forEach(function (o) { o.disconnect(); }); }
  function resumeAll() { observers.forEach(function (o) { o.observe(o.__el, { childList: true, subtree: true }); }); }

  function place(container, total, startPct) {
    var ex = container.querySelector('.foz-fsb-wrap');
    if (ex) ex.remove();
    container.insertAdjacentHTML('afterbegin', html(total, startPct));
  }

  function render(total) {
    injectCSS();
    pauseAll();
    var drawer = document.querySelector('#CartDrawer .cart-drawer__form');
    var page = document.querySelector('#main-cart-items .js-contents') || document.querySelector('#main-cart-items');
    if (total > 0) {
      var start = lastPct === null ? 0 : lastPct;
      if (drawer) place(drawer, total, start);
      if (page) place(page, total, start);
      lastPct = calc(total).barPct;
      // next frame: slide each fill from its start width to the new target
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          document.querySelectorAll('.foz-fsb__fill').forEach(function (f) {
            f.style.width = f.getAttribute('data-target') + '%';
          });
        });
      });
    } else {
      document.querySelectorAll('.foz-fsb-wrap').forEach(function (n) { n.remove(); });
      lastPct = null;
    }
    resumeAll();
  }

  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { render(c.total_price); })
      .catch(function () {});
  }

  function observe(el) {
    if (!el || !window.MutationObserver) return;
    var timer;
    var o = new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(refresh, 150); });
    o.__el = el;
    o.observe(el, { childList: true, subtree: true });
    observers.push(o);
  }

  function boot() {
    observe(document.querySelector('#CartDrawer'));
    observe(document.querySelector('#main-cart-items'));
    refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
